// extracted by mini-css-extract-plugin
export var cancelButton = "_lo-5";
export var content = "_lo-3";
export var createButton = "_lo-6";
export var drawerContainer = "_lo-0";
export var footer = "_lo-2";
export var header = "_lo-1";
export var orderFormColumn = "_lo-4";